// Tracking des clics outbound (liens externes) et downloads. Delegation click
// sur document : un seul listener pour toute l'app, marche aussi pour les liens
// injectes dynamiquement.

import { trackEvent } from './event';

const DOWNLOAD_EXT_REGEX = /\.(pdf|docx?|xlsx?|pptx?|odt|ods|odp|zip|rar|7z|csv|epub)$/i;

let listenerAttached = false;

function trackingDisabled(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie.includes('matomo_ignore=1');
}

function findAnchor(target: EventTarget | null): HTMLAnchorElement | null {
  let el = target as HTMLElement | null;
  let depth = 0;
  while (el && depth < 6) {
    if (el.tagName === 'A' && (el as HTMLAnchorElement).href) return el as HTMLAnchorElement;
    el = el.parentElement;
    depth++;
  }
  return null;
}

function onClick(ev: MouseEvent): void {
  if (trackingDisabled()) return;
  const a = findAnchor(ev.target);
  if (!a) return;
  const href = a.href;
  if (!href) return;
  if (href.startsWith('javascript:') || href === '#' || href.endsWith('#')) return;

  if (href.startsWith('mailto:')) {
    trackEvent('Outbound', 'mailto', { name: href.replace(/^mailto:/, '').slice(0, 150) });
    return;
  }
  if (href.startsWith('tel:')) {
    trackEvent('Outbound', 'tel', { name: href.replace(/^tel:/, '').slice(0, 150) });
    return;
  }

  let url: URL;
  try {
    url = new URL(href, window.location.href);
  } catch {
    return;
  }

  if (url.host === window.location.host) {
    if (DOWNLOAD_EXT_REGEX.test(url.pathname)) {
      const parts = url.pathname.split('/');
      const filename = parts[parts.length - 1] || url.pathname;
      trackEvent('Download', filename.slice(0, 150), { name: url.pathname });
    }
    return;
  }
  trackEvent('Outbound', url.hostname.replace(/^www\./, ''), { name: url.href.slice(0, 200) });
}

export function initOutboundTracker(): void {
  if (typeof document === 'undefined' || listenerAttached) return;
  document.addEventListener('click', onClick, { capture: true, passive: true });
  listenerAttached = true;
}
